import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import 'core-js/modules/es6.array.fill.js';
import React__default from 'react';
import { ProgressBar } from '@blueprintjs/core';
import { HTMLHeading } from '../html-heading/html-heading.js';

var _excluded = ["description", "fill", "formatNumber", "intent", "loading", "progressBarProps", "showPercentage", "title", "titleTagLevel", "value"];

var AdvancedProgressBarWrap = /*#__PURE__*/_styled("div", {
  target: "e1o0ouih0"
})("max-width:640px;min-width:200px;width:", function (_ref) {
  var fill = _ref.fill;
  return fill ? "100%" : "auto";
}, ";");

var AdvancedProgressBarTitle = /*#__PURE__*/_styled(HTMLHeading, {
  target: "e1o0ouih1"
})({
  name: "131m7ec",
  styles: "width:100%;margin-bottom:0.5rem !important;"
});

var AdvancedProgressBarBody = /*#__PURE__*/_styled("div", {
  target: "e1o0ouih2"
})("display:", function (_ref2) {
  var hasDescription = _ref2.hasDescription;
  return hasDescription ? "block" : "flex";
}, ";align-items:center;.bp3-progress-bar{margin-bottom:", function (_ref3) {
  var hasDescription = _ref3.hasDescription;
  return hasDescription ? "0.5rem" : "0";
}, ";}");

var AdvancedProgressBarDetails = /*#__PURE__*/_styled("div", {
  target: "e1o0ouih3"
})({
  name: "10aoe7z",
  styles: "display:flex;justify-content:space-between;font-size:0.75rem;line-height:1rem;"
});

var AdvancedProgressBarDescription = /*#__PURE__*/_styled("div", {
  target: "e1o0ouih4"
})();

var AdvancedProgressBarPercentage = /*#__PURE__*/_styled("div", {
  target: "e1o0ouih5"
})({
  name: "6ahz6o",
  styles: "min-width:3em;margin-left:0.5rem;text-align:right;white-space:nowrap;"
});

var AdvancedProgressBar = /*#__PURE__*/React__default.forwardRef(function (_ref4, ref) {
  var description = _ref4.description,
      fill = _ref4.fill,
      formatNumber = _ref4.formatNumber,
      intent = _ref4.intent,
      loading = _ref4.loading,
      progressBarProps = _ref4.progressBarProps,
      showPercentage = _ref4.showPercentage,
      title = _ref4.title,
      _ref4$titleTagLevel = _ref4.titleTagLevel,
      titleTagLevel = _ref4$titleTagLevel === void 0 ? "h4" : _ref4$titleTagLevel,
      value = _ref4.value,
      props = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/React__default.createElement(AdvancedProgressBarWrap, _extends({
    className: "vds-advanced-progress-bar",
    fill: fill,
    ref: ref
  }, props), title && /*#__PURE__*/React__default.createElement(AdvancedProgressBarTitle, {
    bold: true,
    className: "vds-progress-bar-title",
    styleLevel: "h6",
    tagLevel: titleTagLevel
  }, title), /*#__PURE__*/React__default.createElement(AdvancedProgressBarBody, {
    hasDescription: !!description,
    className: "vds-advanced-progress-bar-body"
  }, /*#__PURE__*/React__default.createElement(ProgressBar, _extends({
    intent: intent,
    value: value
  }, progressBarProps)), (description || showPercentage) && /*#__PURE__*/React__default.createElement(AdvancedProgressBarDetails, {
    className: "vds-advanced-progress-bar-details"
  }, description && /*#__PURE__*/React__default.createElement(AdvancedProgressBarDescription, {
    className: "vds-advanced-progress-bar-description"
  }, description), showPercentage && /*#__PURE__*/React__default.createElement(AdvancedProgressBarPercentage, {
    className: "vds-advanced-progress-bar-percentage"
  }, loading ? "-" : formatNumber(value !== null && value !== void 0 ? value : 0, {
    style: "percent"
  })))));
});

export { AdvancedProgressBar };
//# sourceMappingURL=advanced-progress-bar.js.map
